// @ts-nocheck

import { createContext, useContext } from 'react';

type ExpandedBetGroupContextProps = {
  expandOnMount?: boolean;
  expandedBetGroups: { [key: string]: boolean };
  setExpandedBetGroups: (...params: unknown) => unknown;
};

export const ExpandedBetGroupContext = createContext<ExpandedBetGroupContextProps>({
  expandOnMount: false,
  expandedBetGroups: {},
  setExpandedBetGroups: () => false,
});

export const useExpandedBetGroupContext = () => useContext(ExpandedBetGroupContext);
